import config from '../../config';
import { React } from "react";
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

var url = config.nav.url;
var login_url = config.nav.full_url+'/login';
var login_link = url+'login';
var dashboard_link = url+'dashboard';
var link;

var model_submission_link = "https://firebasestorage.googleapis.com/v0/b/apafrep.appspot.com/o/Annexe_A_%20Proposition_Candidature.doc?alt=media&token=915393a8-d973-4428-8000-4861ff82ff41";
var cadre_logique_link = "https://firebasestorage.googleapis.com/v0/b/apafrep.appspot.com/o/Annexe_B_Cadre%20logique_et_Activit%C3%A9s.doc?alt=media&token=29acddf8-f138-4a9c-8ff4-9a0c1a9f25b9";
var submission_calendar = "https://firebasestorage.googleapis.com/v0/b/apafrep.appspot.com/o/Annexe_C_Calendrier_du_micro_projet.xlsx?alt=media&token=6f34a71d-8011-432f-895c-1a953dc44b73";
var budget_model_link = "https://firebasestorage.googleapis.com/v0/b/apafrep.appspot.com/o/Annexe_D_Budget.xlsx?alt=media&token=12dfc793-982f-4b26-ba2f-14a98f6929e9";
var ligne_directrices_link = "https://firebasestorage.googleapis.com/v0/b/apafrep.appspot.com/o/LIGNES%20DIRECTRICES%20APAFReP.pdf?alt=media&token=3c8f3aba-5574-4131-8efa-6915a9ce98fb";

if(localStorage.getItem('id') == null){
    link = login_link;
}
else {
    link = dashboard_link;
}


const About = () => {
    const { t } = useTranslation();

    return (
        <div>
            <section id="about">
                <div className="container my-5 py-5">
                <p className="text-left fw-bolder fs-5 mb-5">{t('about_text')}</p>
                    <div className="row mb-5">
                        <div className="col-md-9">
                            <div>
                                <h1 className="display-6 mb-2">{t('title_1')}</h1>
                                <hr className="w-50"/>
                                <p className="lead mt-4 mb-4">{t('text_1_1')}  
                                « <a href="https://www.ifdd.francophonie.org/2eme-appel-a-propositions-soutien-aux-innovations-environnementales-au-cameroun-et-en-republique-democratique-du-congo/" 
                                    target="_blank" rel='noreferrer'>
                                {t('text_1_2')}</a> », {t('text_1_3')}.</p>
                            </div>
                            <div>
                                <h1 className="display-6 mt-4 mb-2">{t('title_2')}</h1>
                                <hr className="w-75"/>
                                <p className="lead mt-4 mb-4">{t('text_2_1')}:</p>
                                <ul>
                                    <li>{t('text_2_2')}; </li>
                                    <li>{t('text_2_3')}; </li>
                                    <li>{t('text_2_4')};</li>
                                    <li>{t('text_2_5')}; </li>
                                    <li>{t('text_2_6')}.</li>
                                </ul>
                                <p className="lead mt-4 mb-4">{t('text_2_7')}.</p>                        
                            </div>
                            <div>
                                <h1 className="display-6 mb-2">{t('title_3')}</h1>
                                <hr className="w-50"/>
                                <p className="lead mt-4 mb-4">{t('text_3_1')} :</p>
                                <ul>
                                    <li> {t('text_3_2')};</li>
                                    <li> {t('text_3_3')};</li>
                                    <li> {t('text_3_4')}.</li>
                                </ul>
                                <p className="lead">{t('text_3_5')} <a href={ligne_directrices_link} target="_blank" rel="noopener noreferrer">{t('text_3_6')}</a>.</p>
                            </div>
                            <div>
                                <h1 className="display-6 mb-2">{t('title_4')}</h1>
                                <hr className="w-50"/>
                                <p className="lead mt-4 mb-4">{t('text_4_1')} <a href={link}>{t('text_4_2')}</a> {t('text_4_3')}. {t('text_4_4')} : <a href={link}>{login_url}</a>. {t('text_4_5')} <a href='mailto:ngatchou_alban@yahoo.fr'>ngatchou_alban@yahoo.fr</a> {t('text_4_6')} +237 6 77 43 74 41</p>
                                <p className="lead">{t('text_4_7')} :</p>
                                <ul>
                                    <li>{t('text_4_8')};</li>
                                    <li>{t('text_4_9')}; </li>
                                    <li>{t('text_4_10')};</li>
                                    <li>{t('text_4_11')};</li>
                                    <li>{t('text_4_12')};</li>
                                    <li>{t('text_4_13')};</li>
                                    <li>{t('text_4_14')};</li>
                                    <li>{t('text_4_15')}.</li>
                                </ul>
                            </div>
                            <div>
                                <h1 className="display-6 mb-2">{t('title_5')} </h1>
                                <hr className="w-75"/>
                                <p className="lead mt-4 mb-4">{t('text_5_1')} <a href={ligne_directrices_link} target="_blank" rel="noopener noreferrer">{t('text_3_6_b')}</a>.</p>
                                <p className="lead">{t('text_5_2')} <a href={ligne_directrices_link} target="_blank" rel="noopener noreferrer">{t('text_3_6')}</a> {t('text_5_3')}.</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                        <div>
                                <h3 className="display-6 mb-2">{t('title_6')}</h3>
                                <hr className="w-20"/>
                                <ul>
                                    <li><a href={model_submission_link} target="_blank" rel="noopener noreferrer">{t('text_6_1')};</a></li>
                                    <li><a href={cadre_logique_link} target="_blank" rel="noopener noreferrer">{t('text_6_2')};</a></li>
                                    <li><a href={budget_model_link} target="_blank" rel="noopener noreferrer">{t('text_6_3')};</a></li>
                                    <li><a href={submission_calendar} target="_blank" rel="noopener noreferrer">{t('text_6_4')};</a></li>
                                </ul>
                                <NavLink to={dashboard_link} className="btn btn-outline-primary ms-3">
                                    <i className="me-2"></i><strong>{t('my_application')}</strong></NavLink>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h3 className="display-6 mb-2">{t('title_7')}</h3>
                        <hr className="w-50"/>
                        <div className="partners">
                            <div className="row me-4">
                                <div className="col-lg-3">
                                    <a href="https://universitekongo.cd/" target="_blank" rel='noreferrer'><img src="/assets/partners/KONGO.png" alt="U KONGO" /></a>
                                </div>
                                <div className="col-lg-3">
                                    <a href="https://www.eden-africa.org/" target="_blank" rel='noreferrer'><img src="/assets/partners/EDENAFRICA.png" alt="EDEN AFRICA" /></a>
                                </div>
                                <div className="col-lg-3">
                                    <a href="https://www.ewb-international.com/" target="_blank" rel='noreferrer'><img src="/assets/partners/EWB.png" alt="EWB" /></a>
                                </div>
                                <div className="col-lg-3">
                                    <a href="https://www.francophonie.org/" target="_blank" rel='noreferrer'><img src="/assets/partners/Francophonie.png" height={75} alt="Francophonie" /></a>
                                    <a href="https://www.ifdd.francophonie.org/" target="_blank" rel='noreferrer'><img src="/assets/partners/IFDD.png" height={50} alt="IFDD" className='w-20'/></a>
                                </div>
                                <div className="col-lg-4">
                                    <a href="http://www.acp.int/fr" target="_blank" rel='noreferrer'><img src="/assets/partners/images.png" alt="OEACP" /></a>
                                    <p>Programme de recherche et d'innovation de l'OEACP</p>
                                </div>
                                <div className="col-lg-4">
                                    <a href="http://www.acp.int/fr" target="_blank" rel='noreferrer'><img src="/assets/partners/ACP.png" alt="ACP"/></a>
                                    <p>Mis en oeuvre par le secrétariat de l'OEACP</p>
                                </div>
                                <div className="col-lg-4">
                                    <a href="https://european-union.europa.eu/index_fr" target="_blank" rel='noreferrer'><img src="/assets/partners/UE.jpg" alt="Union Européenne" /></a>
                                    <p >Financé par l'Union Européenne</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default About;
